module.exports = __webpack_public_path__ + "static/faq1-dd92d769c740b044253a109af4cbcfbb.jpg";